import { render, staticRenderFns } from "./PeriodsFetcher.vue?vue&type=template&id=84b30e64"
import script from "./PeriodsFetcher.vue?vue&type=script&lang=js"
export * from "./PeriodsFetcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports